import { Vue } from "vue-property-decorator";
import "./app-tag.scss";

export class AppTagComponent extends Vue {}
